(() => {
  function activate(root, tab) {
    root.querySelectorAll('[role="tab"]').forEach(button => {
      const selected = button === tab;
      button.setAttribute('aria-selected', String(selected));
      button.tabIndex = selected ? 0 : -1;
      document.getElementById(button.getAttribute('aria-controls')).hidden = !selected;
    });
  }
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-ba-product-tabs] [role="tab"]');
    if (tab) activate(tab.closest('[data-ba-product-tabs]'), tab);
    const swatch = event.target.closest('[data-ba-photo-swatch]');
    if (!swatch || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const card = swatch.closest('.ba-card, .product-item');
    if (!card || !swatch.dataset.photo) return;
    const image = card.querySelector('.ba-card__img1, .card-media img');
    if (!image) return;
    event.preventDefault();
    image.removeAttribute('srcset');
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-src');
    image.src = swatch.dataset.photo;
    card.classList.add('ba-photo-selected');
    card.querySelectorAll('.ba-card__img2, .card-media img').forEach(other => { if (other !== image) other.style.display = 'none'; });
    card.querySelectorAll('.ba-photo-swatch').forEach(link => link.removeAttribute('aria-current'));
    swatch.setAttribute('aria-current', 'true');
    card.querySelectorAll('.ba-card__media, .ba-card__title, .card-media > a, .card-title').forEach(link => { link.href = swatch.href; });
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-ba-product-tabs] [role="tab"]');
    if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const root = tab.closest('[data-ba-product-tabs]');
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const rtl = document.documentElement.dir === 'rtl';
    const delta = (event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1);
    const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (tabs.indexOf(tab) + delta + tabs.length) % tabs.length;
    activate(root, tabs[index]); tabs[index].focus();
  });
})();

